import axios from 'axios'
import translate from '../utils/translations'
import refreshAttribute from '../utils/refreshAttribute'

export default {
  name: 'offers',

  ui: {
    'filters[]': '[js-offers-filter]',
    'toggle[]': '[js-offers-filter-parent]',
    toggleWrap: '[js-offers-toggle-wrap]',
    cards: '[js-offers-cards]',
    input: '[js-offers-input]',
    paginationText: '[js-offers-pagination-text]',
    paginationButton: '[js-offers-pagination-button]',
    paginationBar: '[js-offers-pagination-bar]',
  },

  typingTimer: null,
  currentPage: 1,
  filters: {
    jobtype: [],
    place: [],
    contract: [],
    job: [],
  },

  events: [
    {
      on: 'click',
      target: 'filters',
      handle ({ target }) {
        const currentFilters = this.filters[target.closest('[js-offers-filter-parent]').dataset.type]

        if (target.checked) {
          currentFilters.push(target.name)
        } else {
          currentFilters.splice(currentFilters.indexOf(target.name), 1)
        }

        this.resetParams()
        this.createLoader(this.ui.toggleWrap)
      },
    },
    {
      on: 'input',
      target: 'input',
      handle () {
        clearTimeout(this.typingTimer)

        this.typingTimer = setTimeout(() => {
          this.resetParams()
        }, 1000)
      },
    },
    {
      on: 'keydown',
      target: 'input',
      handle (event) {
        clearTimeout(this.typingTimer)

        if (event.keyCode === 13) {
          this.resetParams()
        }
      },
    },
  ],

  ajaxRequest () {
    const formData = new FormData()

    formData.append('jobtype', this.filters.jobtype.join('//'))
    formData.append('place', this.filters.place.join('//'))
    formData.append('job', this.filters.job.join('//'))
    formData.append('contract', this.filters.contract.join('//'))
    formData.append('queryString', this.ui.input.value)
    formData.append('page', this.currentPage)
    formData.append('nonce', this.props.nonce)
    formData.append('action', this.props.action)

    this.ui.cards.classList.add('is-loading')

    axios.post(this.props.url, formData)
      .then(response => {
        this.totalPages = Math.ceil(response.data.data.totalCards / 9)
        this.nbCards = response.data.data.totalCards
        this.ui.cards.innerHTML = this.nbCards > 0 ? response.data.data.content : this.noResult
        this.styleProgressBar()
        this.ui.cards.classList.remove('is-loading')
        this.ui.toggleWrap.classList.remove('is-loading')

        this.ui.cards.querySelectorAll('.card-offer').forEach(el => refreshAttribute('js-dynamic-modal')(el))

        if (this.ui.paginationButton) {
          this.ui.paginationButton.classList.remove('is-loading')
        }

        if (this.el.querySelector('.loader')) this.el.querySelector('.loader').remove()
      })
      .catch(e => {
        console.log('error', e)
      })
  },

  styleProgressBar () {
    if (this.ui.paginationButton) {
      if (this.nbCards > 0) {
        this.pagination.classList.remove('hidden')
        this.ui.paginationText.textContent = translate('OFFERS_PROGRESS').replace('*current*', this.nbCards > 0 ? this.currentPage * 9 : 0).replace('*total*', this.nbCards)

        const widthPercentage = (this.currentPage) * (100 / this.totalPages)
        this.ui.paginationBar.setAttribute('style', `width: ${widthPercentage}%;`)
        if (this.currentPage === this.totalPages) {
          this.ui.paginationText.textContent = translate('OFFERS_PROGRESS').replace('*current*', this.nbCards).replace('*total*', this.nbCards)
          this.ui.paginationButton.classList.add('is-hidden')
        }
      } else {
        this.pagination.classList.add('hidden')
      }
    }
  },

  resetParams () {
    this.currentPage = 1
    this.ajaxRequest()

    if (this.ui.paginationButton) {
      this.ui.paginationButton.classList.remove('is-hidden')
    }
  },

  componentDidMount () {
    this.totalPages = Math.ceil(this.props.nbCards / 9)
    this.nbCards = this.props.nbCards
    this.noResult = `<div class="col-12 text-coral">${translate('OFFERS_NO_RESULT')}</div>`
    this.pagination = this.el.querySelector('.pagination')
    this.styleProgressBar()

    // not always present so can't be put in events
    if (this.ui.paginationButton) {
      this.ui.paginationButton.addEventListener('click', () => {
        this.currentPage = this.currentPage + 1
        this.ajaxRequest()

        this.createLoader(this.ui.paginationButton)
      })
    }
  },

  createLoader (container) {
    const loader = document.createElement('div')
    loader.classList.add('loader')
    container.append(loader) // 'append' rather than 'prepend' not to break filters CSS
    container.classList.add('is-loading')
  },
}
